import { render, staticRenderFns } from "./LockerDeliveriesTitle.vue?vue&type=template&id=2121f458&scoped=true"
import script from "./LockerDeliveriesTitle.vue?vue&type=script&lang=js"
export * from "./LockerDeliveriesTitle.vue?vue&type=script&lang=js"
import style0 from "./LockerDeliveriesTitle.vue?vue&type=style&index=0&id=2121f458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2121f458",
  null
  
)

export default component.exports